import { useState } from "react";
import { Maximize2, Play } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { DemoBadge } from "@/components/Logo";

const Thumb = ({ item, i, active, name, onClick }) => (
  <button data-testid={item.video ? `gallery-video-thumb-${i}` : `gallery-thumb-${i}`} onClick={onClick}
    className={`relative shrink-0 w-16 h-20 lg:w-20 lg:h-24 overflow-hidden border bg-[#242321] transition-colors ${active ? "border-[#39251D]" : "border-transparent opacity-70 hover:opacity-100"}`}>
    {item.video ? <video src={`${item.src}#t=0.1`} muted playsInline preload="metadata" className="w-full h-full object-cover pointer-events-none" />
      : <img src={item.src} alt={`${name} ${i + 1}`} className="w-full h-full object-cover" />}
    {item.video && <span className="absolute inset-0 flex items-center justify-center"><span className="w-7 h-7 rounded-full bg-[#F5F0E8]/90 flex items-center justify-center"><Play className="w-3.5 h-3.5 ml-0.5 text-[#39251D]" /></span></span>}
  </button>
);

export const Gallery = ({ images, videos = [], name, demo, alts = [] }) => {
  const items = [...images.map((src) => ({ src })), ...videos.map((src) => ({ src, video: true }))];
  const [active, setActive] = useState(0);
  const [origin, setOrigin] = useState("50% 50%");
  const [zoom, setZoom] = useState(false);
  const [lightbox, setLightbox] = useState(false);
  const cur = items[active] || items[0];

  const onMove = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    setOrigin(`${((e.clientX - r.left) / r.width) * 100}% ${((e.clientY - r.top) / r.height) * 100}%`);
  };

  return (
    <div className="flex flex-col-reverse lg:flex-row gap-4" data-testid="product-gallery">
      <div className="flex lg:flex-col gap-3 overflow-x-auto no-scrollbar">
        {items.map((it, i) => <Thumb key={i} item={it} i={i} active={i === active} name={name} onClick={() => setActive(i)} />)}
      </div>
      {cur?.video ? (
        <div className="relative flex-1 aspect-[4/5] overflow-hidden bg-[#242321]" data-testid="gallery-main-video">
          <video key={cur.src} src={cur.src} controls playsInline autoPlay muted loop className="w-full h-full object-contain" />
        </div>
      ) : (
        <div className="relative flex-1 aspect-[4/5] overflow-hidden bg-[#E9DFCE] cursor-zoom-in" data-testid="gallery-main"
          onMouseEnter={() => setZoom(true)} onMouseLeave={() => setZoom(false)} onMouseMove={onMove} onClick={() => setLightbox(true)}>
          <img src={cur?.src} alt={alts[active] || name} className="w-full h-full object-cover transition-transform duration-300" style={{ transformOrigin: origin, transform: zoom ? "scale(2)" : "scale(1)" }} />
          {demo && <DemoBadge className="absolute top-4 left-4" testId="product-demo-badge" />}
          <span className="absolute bottom-4 right-4 w-9 h-9 rounded-full bg-[#F5F0E8]/85 flex items-center justify-center"><Maximize2 className="w-4 h-4" /></span>
        </div>
      )}
      <Dialog open={lightbox} onOpenChange={setLightbox}>
        <DialogContent className="max-w-4xl p-0 bg-[#242321] border-none rounded-none" data-testid="gallery-lightbox">
          <DialogTitle className="sr-only">{name}</DialogTitle>
          <img src={cur?.src} alt={name} className="w-full max-h-[85vh] object-contain" />
        </DialogContent>
      </Dialog>
    </div>
  );
};
